<template>
  <div>
    <b-modal
        id="email-lang-modal"
        centered
        size="sm"
        :title="$t('pages.template_builder.add_new_lang_modal.title')"
        title-class="font-18"
        @ok="handleOk"
    >
      <b-form-select class="form-select"
                     v-model="selectedLanguage"
                     :options="filteredLangs"
                     text-field="name"></b-form-select>
    </b-modal>
  </div>
</template>

<script>
import CountriesMixin from "../../../mixins/CountriesMixin";

export default {
  name: "EmailLangSelect",
  mixins: [CountriesMixin],
  props: ['availableLangs'],
  data() {
    return {
      selectedLanguage: null,
      filteredLangs: [],
    }
  },
  watch: {
    availableLangs(val) {
      this.filterLang(val)
    }
  },
  methods: {
    handleOk() {
      this.$emit('selectedLang', {value: this.selectedLanguage})
    },
    filterLang(val) {
      this.filteredLangs = this.languages.filter(item => {
        return !val.includes(item.value)
      })
      this.selectedLanguage = this.filteredLangs[0].value
    }
  },
  created() {
    this.filterLang(this.availableLangs)
  }
}
</script>

<style scoped>

</style>